<template>
  <div id="esc-rich-content"></div>
</template>

<script setup>
import {onMounted, onUnmounted} from "vue";
import {getActiveLanguage} from "laravel-vue-i18n";

const props = defineProps({
  product: Object
});
const reMount = () => {
  const headElement = document.getElementsByTagName("head")[0];
  const oldScripts = document.querySelectorAll("[data-shop-id='1517']");
  for (let i = 0; i < oldScripts.length; ++i) {
    headElement.removeChild(oldScripts[i]);
  }
  const esScript = document.createElement("script");
  esScript.async = true;
  esScript.setAttribute("data-shop-id", "1517");
  esScript.setAttribute("data-content-language", getActiveLanguage());
  esScript.setAttribute("data-product-code", props.product.barcode);
  esScript.setAttribute("data-page-embed-id", "esc-rich-content");
  esScript.src = "https://delivery.estorecontent.com/static/rich_content.js";
  headElement.appendChild(esScript);
};
onUnmounted(() => reMount());
onMounted(() => reMount());
</script>
